import React from "react";
import AuthHeader from "../components/Layouts/AuthHeader";
import RegistrationForm from "../components/Auth/RegistrationForm";

const Home = () => {
  return (
    <>
      <AuthHeader />
      <RegistrationForm />
    </>
  );
};

export default Home;
